import React from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import StepperButtons from "./StepperButtons";
import MainCard from '../berry/ui-component/cards/MainCard';
import {Link} from "react-router-dom";
import {
    Grid,
    Typography
} from "@mui/material";


const FormStepperContainer = React.forwardRef((props, ref) => {


    const { handleNext, label, children, activeStep, nbStep, id, handleBack, handleSave, autoComplete } = props;

    return (
        <ValidatorForm
            ref={ref}
            onSubmit={handleNext}
            onError={errors => console.log(errors)}
            autoComplete={autoComplete}
        >
            {/*<SubTitle label={label} variant={"h5"} />*/}
            <br />

            <MainCard sx={{  marginBottom: -2  }}>
                <Grid container>
                    <Grid item xs={12}>
                        {children}
                    </Grid>
                </Grid>
            </MainCard>

            <MainCard sx={{ marginBottom: 10, marginTop: 5, paddingBottom: 2 }}>
                <Grid container>
                    <Grid item xs={0} sm={1}>
                    </Grid>
                    {activeStep !== 1 && activeStep !== 2 ? (
                        <>
                            <Grid item xs={12} sm={5} sx={{ marginBottom: 3 }}>
                                <Typography variant="body2" sx={{ marginTop: 3 }}>
                                    Les informations recueillies par <b>UNIPREVOYANCE</b>, en tant que responsable de traitement, font l'objet d'un traitement informatique pour la gestion de votre compte client
                                    (<Link to={`/ui/informations-legales`} target={"_blank"}>En savoir plus</Link>).
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <Grid container justifyContent="flex-end">
                                    <StepperButtons
                                        canSave={id !== undefined}
                                        activeStep={activeStep}
                                        nbStep={nbStep}
                                        handleNext={handleNext}
                                        handleBack={handleBack}
                                        handleSave={handleSave}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        <Grid item xs={12} sm={10} >
                            <Grid container justifyContent="flex-end" sx={{ paddingBottom:10 }}>
                                <StepperButtons
                                    canSave={id !== undefined}
                                    activeStep={activeStep}
                                    nbStep={nbStep}
                                    handleNext={handleNext}
                                    handleBack={handleBack}
                                    handleSave={handleSave}
                                />
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={0} sm={1}></Grid>
                </Grid>
            </MainCard>
        </ValidatorForm>
    )
});
export default FormStepperContainer
